import { useQuery } from '@tanstack/react-query';
import { getSeatsIOEventReport, SeatsIOAvailabilityReport } from 'services/Seats';

export const useGetSeatsIOEventReport = (eventKey: string | null | undefined) => {
	return useQuery<SeatsIOAvailabilityReport>({
		queryKey: ['seatsIOEventReport', eventKey],
		queryFn: () => {
			if (!eventKey) throw new Error('Event key is required');
			return getSeatsIOEventReport(eventKey);
		},
		enabled: !!eventKey,
		staleTime: 2 * 60 * 1000,
		cacheTime: 5 * 60 * 1000,
	});
};
